module.exports = __webpack_public_path__ + "static/media/alexa_logo_horizontal.6b70f06d.svg";